import React from "react";
import { useAppState } from "../state/AppStateContext";
import { LANGUAGE_SHORT } from "../i18n/strings";

export default function TopBar() {
  const { lang, toggleLangSheet } = useAppState();

  return (
    <div style={styles.wrap}>
      <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="" aria-hidden="true" style={styles.logo} />
      <div style={styles.brandGroup}>
        <div style={styles.brand}>
          Vaya<span style={{ color: "var(--color-accent)" }}> Taxi</span>
        </div>
        <a
          href="https://www.quantummindsoftware.com"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.tagline}
        >
          Developed by QuantumMind Software
        </a>
      </div>
      <button type="button" className="btn" onClick={toggleLangSheet} style={styles.langBtn}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="9" />
          <path d="M3 12h18M12 3c3 3.5 3 14 0 18M12 3c-3 3.5-3 14 0 18" />
        </svg>
        {LANGUAGE_SHORT[lang] || "EN"}
      </button>
    </div>
  );
}

const styles = {
  wrap: { display: "flex", alignItems: "center", gap: 10, padding: "18px 18px 10px", flex: "none" },
  logo: {
    width: 42,
    height: 42,
    objectFit: "contain",
    flex: "none",
    filter: "drop-shadow(0 0 9px rgba(32,198,183,.42))",
  },
  brandGroup: { display: "flex", flexDirection: "column", gap: 3 },
  brand: { fontFamily: "var(--font-heading)", fontSize: 21, lineHeight: 1 },
  tagline: { color: "var(--color-neutral-700)", fontSize: 9, lineHeight: 1.2, textDecoration: "none" },
  langBtn: { marginLeft: "auto", gap: 6, padding: "8px 14px", background: "var(--panel)", fontSize: 13, color: "var(--color-text)" },
};
